var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "15px",
    viewBox: "0 0 13 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0.288675135 L12.4951905,3.46132487 C12.8045916,3.63995766 12.9951905,3.97008468 12.9951905,4.32735027 L12.9951905,10.6726497 C12.9951905,11.0299153 12.8045916,11.3600423 12.4951905,11.5386751 L7,14.7113249 C6.69059892,14.8899577 6.30940108,14.8899577 6,14.7113249 L0.504809472,11.5386751 C0.195408395,11.3600423 0.00480947162,11.0299153 0.00480947162,10.6726497 L0.00480947162,4.32735027 C0.00480947162,3.97008468 0.195408395,3.63995766 0.504809472,3.46132487 L6,0.288675135 C6.30940108,0.11004234 6.69059892,0.11004234 7,0.288675135 Z",
    id: "Polygon-Copy-20",
    fill: "#4157A6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniOrder);
export default __webpack_public_path__ + "static/media/mini-order.42f9935c7127f9af5ae4ee8349bc3fdd.svg";
export { ForwardRef as ReactComponent };